/**
 * @file connection.ts
 * @author Rapoo Device SDK Team
 * @description 设备连接类型语义化枚举
 *
 * 业务层通过设备实例的 getConnectionType() 获取语义化的连接类型，
 * 无需关心底层具体数值（0xff / 0xa5 等）。
 *
 * 各设备驱动子类负责将原始 connectionType 数值转换为本枚举，
 * 不同型号设备可根据自身情况决定转换规则。
 */

/** 设备连接类型（语义化枚举） */
export enum ConnectionType {
  /** 有线连接（USB） */
  Wired = 0,
  /** 无线连接（2.4G / 接收器） */
  Wireless = 1,
  /** 蓝牙连接 */
  Bluetooth = 2,
}
